import { CardWrapper, IconWrapper } from "./styles";

interface CardProps {
  children: React.ReactNode;
}

export default function CardHeader ({children}: CardProps) {
  return <CardWrapper><IconWrapper>{children}</IconWrapper></CardWrapper>
}